export default __webpack_public_path__ + "static/media/icon_zone_control_11.4ba73c6e.png";